import React, { useState } from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";
import { useDispatch, useSelector } from "react-redux";

import { Collapse } from "Cobalt/Collapse";
import { Modal, ModalHeader, ModalBody, ModalTitle, openModal, closeModal } from "Cobalt/Modal";
import BodyText from "Common/BodyText";
import Button from "Common/Button";
import { Row, Col } from "Common/Grid";
import { Div, Hr } from "Common/HTML";
import Icon from "Common/Icon";

import ClickableFilename from "./ClickableFilename";
import { WAGE_DOC_ISSUE_MODAL_NAME } from "./constants";
import { useModalDescription, getModalName, useDocumentPickerContext, bem } from "./utils";

const ToggleIcon = ({ showInstructions }) => (
  <div>
    <Icon icon={showInstructions ? "angle-up" : "angle-down"} size="normal" className={bem("Carat")} mx={4} />
  </div>
);

const WageDocumentIssueModal = () => {
  const { description, fileInputName, filename, index, title } = useDocumentPickerContext();
  const modalDescription = useModalDescription({
    fileInputName,
    description,
    title,
  });

  const [showInstructions, setShowInstructions] = useState(false);
  const currentlyOpenModal = useSelector((state) => state.openModal);
  const modalName = getModalName(WAGE_DOC_ISSUE_MODAL_NAME, index);
  const dispatch = useDispatch();

  return (
    <Modal show={currentlyOpenModal === modalName} onHide={() => dispatch(closeModal(modalName))} aria-hidden={currentlyOpenModal !== modalName}>
      <ModalHeader closeButton onClick={() => dispatch(closeModal(modalName))}>
        <ModalTitle>Issue With Your Document</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col>
            <BodyText>
              The document you uploaded may not be correct. Please confirm that you uploaded the {title} form. You'll know the form is correct if it lists out
              all employees with their wages for the quarter.
            </BodyText>
          </Col>
        </Row>
        <Row>
          <Col>
            <BodyText
              level={isIntuit() ? 7 : 3}
              className={classnames(bem("HeaderRow"), {
                [bem("HeaderRow", "open")]: false,
              })}
              py={isIntuit() ? 2 : 3}
              mb={0}
              onClick={() => setShowInstructions(!showInstructions)}
              style={{ display: "flex" }}
            >
              View instructions to retrieve this document
              <ToggleIcon showInstructions={showInstructions} />
            </BodyText>
          </Col>
        </Row>
        <Collapse in={showInstructions}>
          <Div
            className={classnames(bem("CollapsingRow"), {
              [bem("CollapsingRow", "intuit")]: isIntuit(),
            })}
          >
            <Row>
              <Col>{modalDescription}</Col>
            </Row>
          </Div>
        </Collapse>
        <Hr m={isIntuit() ? 2 : 3} />
        <Row style={{ padding: "8px 0" }}>
          <Col xs={12} sm={4}>
            <BodyText className={classnames(bem("Title"))}>{title}</BodyText>
          </Col>
          <Col xs={12} sm={4}>
            <Div my={1}>
              <ClickableFilename htmlFor={`input-${fileInputName}`} filename={filename} />

              <Button color="gray" size="medium" fullWidth className={bem("ChangeFileButtonModal")} component="label" htmlFor={`input-${fileInputName}`}>
                Change File
              </Button>
            </Div>
          </Col>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default WageDocumentIssueModal;
